// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid'
import { HtmlPatcher } from './htmlPatcher'

class SunburstChartPatcher implements HtmlPatcher {
  map: Map<string, HTMLImageElement> = new Map()

  canvasToImg = (canvas: HTMLCanvasElement) => {
    const img = document.createElement('img')
    img.setAttribute('src', canvas.toDataURL())
    img.setAttribute('width', `${canvas.offsetWidth}`)
    img.setAttribute('height', `${canvas.offsetHeight}`)

    return img
  }

  preprocess = () => {
    Array.from(document.getElementsByTagName('canvas')).forEach((canvas) => {
      const uuid = `canvas-${uuidv4()}`
      canvas.setAttribute('id', uuid)

      const img = this.canvasToImg(canvas)
      this.map.set(uuid, img)
    })
  }

  replaceCanvasWithImage = (canvas: HTMLCanvasElement) => {
    if (canvas.style.opacity === '0') {
      return
    }

    const uuid = canvas.getAttribute('id')!
    const img = this.map.get(uuid)!

    const parent = canvas.parentNode!
    parent.removeChild(canvas)
    parent.appendChild(img)
  }

  patch = (cloneBody: Element) => {
    Array.from(cloneBody.getElementsByTagName('canvas')).forEach((canvas) => {
      this.replaceCanvasWithImage(canvas)
    })
  }
}

export default SunburstChartPatcher
